import { useQuery } from "@tanstack/react-query";
import { generateSimulationToken, GENERATE_SIMULATION_TOKEN } from "..";

export const useGenerateSimulationTokenQuery = ({
  enabled = false,
  taskId = null,
  refreshToken,
}) => {
  return useQuery({
    queryKey: [GENERATE_SIMULATION_TOKEN, taskId, refreshToken],
    queryFn: () => generateSimulationToken(taskId, refreshToken),
    enabled,
  });
};
